import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import GrammarRulesEmbed from '../components/Exercise/GrammarRulesEmbed';

export default Node.create({
  name: 'grammarRulesExercise',
  group: 'block',
  atom: true,
  draggable: true,
  addAttributes() {
    return {
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {},
      },
      content: {
        default: '',
        parseHTML: element => element.getAttribute('content') || '',
        renderHTML: attributes => {
          if (attributes.content) {
            return {
              content: attributes.content
            };
          }
          return {};
        }
      },
      title: {
        default: 'Grammar Rules',
        parseHTML: element => element.getAttribute('title') || 'Grammar Rules',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: { 
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      }
    };
  },
  parseHTML() {
    return [
      { tag: 'div[data-type="grammar-rules-exercise"]' },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'grammar-rules-exercise' })];
  },
  addNodeView() {
    return ReactNodeViewRenderer(GrammarRulesEmbed);
  },
  addCommands() {
    return {
      insertGrammarRulesExercise:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
}); 